// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { switchClasses } from '@mui/material/Switch';
import { rem } from '../../tokens/conversions';
import { switchColors } from './switchColors';
// Figma has a "switch-frame" with 2px padding around the track, plus a
// transparent 1px border that turns blue on focus.  In MUI the track fills
// the root, so we cannot use padding.  Instead we use margin on the root to
// create the visual gap and an outline for the focus ring (outline does not
// affect layout).  The translate values position the thumb within the track
// accounting for the track's own 1px border.
export var Switch = function(mode) {
    var c = switchColors(mode);
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7, _obj8, _obj9;
    var override = {
        MuiSwitch: {
            styleOverrides: {
                root: (_obj = {
                    margin: rem(2),
                    marginRight: rem(6),
                    padding: rem(0),
                    outline: "".concat(rem(1), " solid transparent"),
                    outlineOffset: rem(1),
                    borderRadius: rem(50),
                    '&:focus-within': {
                        outlineColor: c.focus.border
                    }
                }, _define_property(_obj, "&:has(.".concat(switchClasses.disabled, ")"), {
                    '&:focus-within': {
                        outlineColor: 'transparent'
                    }
                }), _define_property(_obj, "&&& .".concat(switchClasses.track), {
                    borderRadius: rem(50),
                    opacity: 1
                }), _define_property(_obj, "& .".concat(switchClasses.switchBase), {
                    padding: rem(0)
                }), _obj),
                switchBase: (_obj4 = {}, _define_property(_obj4, "& .".concat(switchClasses.thumb), {
                    boxShadow: 'none',
                    color: c.default.knob
                }), _define_property(_obj4, "&:hover", _define_property({}, "& + .".concat(switchClasses.track), {
                    borderColor: c.hover.border
                })), _define_property(_obj4, "&.".concat(switchClasses.checked), (_obj1 = {}, _define_property(_obj1, "& .".concat(switchClasses.thumb), {
                    color: c.checked.knob
                }), _define_property(_obj1, "& + .".concat(switchClasses.track), {
                    backgroundColor: c.checked.knobBackground,
                    border: "".concat(rem(1), " solid ").concat(c.checked.knobBackground)
                }), _obj1)), _define_property(_obj4, "&.".concat(switchClasses.disabled), (_obj3 = {}, _define_property(_obj3, "& .".concat(switchClasses.thumb), {
                    color: c.disabled.knob
                }), _define_property(_obj3, "& + .".concat(switchClasses.track), {
                    backgroundColor: c.default.background,
                    border: "".concat(rem(1), " solid ").concat(c.disabled.background)
                }), _define_property(_obj3, "&.".concat(switchClasses.checked), (_obj2 = {}, _define_property(_obj2, "& .".concat(switchClasses.thumb), {
                    color: c.disabled.knob
                }), _define_property(_obj2, "& + .".concat(switchClasses.track), {
                    backgroundColor: c.disabled.background
                }), _obj2)), _obj3)), _obj4),
                track: {
                    backgroundColor: c.default.background,
                    border: "".concat(rem(1), " solid ").concat(c.default.border),
                    opacity: 1
                },
                sizeMedium: (_obj5 = {
                    width: rem(36),
                    height: rem(20)
                }, _define_property(_obj5, "& .".concat(switchClasses.switchBase), _define_property({
                    transform: "translate(".concat(rem(3), ", ").concat(rem(3), ")")
                }, "&.".concat(switchClasses.checked), {
                    transform: "translate(".concat(rem(19), ", ").concat(rem(3), ")")
                })), _define_property(_obj5, "& .".concat(switchClasses.thumb), {
                    width: rem(14),
                    height: rem(14)
                }), _obj5),
                sizeSmall: (_obj6 = {
                    width: rem(20),
                    height: rem(12)
                }, _define_property(_obj6, "& .".concat(switchClasses.switchBase), _define_property({
                    transform: "translate(".concat(rem(2), ", ").concat(rem(2), ")")
                }, "&.".concat(switchClasses.checked), {
                    transform: "translate(".concat(rem(10), ", ").concat(rem(2), ")")
                })), _define_property(_obj6, "& .".concat(switchClasses.thumb), {
                    width: rem(8),
                    height: rem(8)
                }), _obj6)
            },
            variants: [
                {
                    props: {
                        size: 'large'
                    },
                    style: (_obj9 = {
                        width: rem(40),
                        height: rem(24),
                        outlineWidth: rem(2),
                        outlineOffset: rem(1),
                        '&:focus-within': {
                            outlineWidth: rem(2)
                        }
                    }, _define_property(_obj9, "&&& .".concat(switchClasses.switchBase), (_obj8 = {
                        transform: "translate(".concat(rem(5), ", ").concat(rem(5), ")")
                    }, _define_property(_obj8, "&.".concat(switchClasses.disabled), (_obj7 = {}, _define_property(_obj7, "& + .".concat(switchClasses.track), {
                        backgroundColor: c.default.background,
                        border: "".concat(rem(2), " solid ").concat(c.disabled.background)
                    }), _define_property(_obj7, "&.".concat(switchClasses.checked), _define_property({}, "& + .".concat(switchClasses.track), {
                        backgroundColor: c.disabled.background,
                        border: "".concat(rem(2), " solid ").concat(c.disabled.background)
                    })), _obj7)), _define_property(_obj8, "&.".concat(switchClasses.checked), _define_property({
                        transform: "translate(".concat(rem(21), ", ").concat(rem(5), ")")
                    }, "& + .".concat(switchClasses.track), {
                        backgroundColor: c.checked.knobBackground,
                        border: "".concat(rem(2), " solid ").concat(c.checked.knobBackground),
                        opacity: 1
                    })), _obj8)), _define_property(_obj9, "& .".concat(switchClasses.thumb), {
                        width: rem(14),
                        height: rem(14)
                    }), _define_property(_obj9, "& .".concat(switchClasses.track), {
                        borderWidth: rem(2)
                    }), _obj9)
                }
            ],
            defaultProps: {
                disableRipple: true
            }
        }
    };
    return override;
};

//# sourceMappingURL=Switch.js.map